import { Link } from "react-router-dom";

export const COMPANY = {
  name: "E.C Sports Solutions S.L.",
  address: "[address]",
  cif: "[number]",
  email: "support@play-maker.eu",
};

export function PublicFooter({ className = "" }) {
  return (
    <footer className={`text-[11px] leading-relaxed text-slate-500 ${className}`} data-testid="public-footer">
      Playmaker is a product of {COMPANY.name} · {COMPANY.address} · CIF {COMPANY.cif} ·{" "}
      <Link to="/privacy" className="underline hover:text-slate-900" data-testid="footer-privacy">Privacy</Link> ·{" "}
      <Link to="/terms" className="underline hover:text-slate-900" data-testid="footer-terms">Terms</Link> ·{" "}
      <a href={`mailto:${COMPANY.email}`} className="underline hover:text-slate-900" data-testid="footer-email">{COMPANY.email}</a>
    </footer>
  );
}
